import { RadioFilterGroup, RadioFilterOption } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AssortmentView } from '@retail/my-assortment/types';
import { useMemo } from 'react';

interface Props {
  selectedAssortmentView: AssortmentView;
  selectAssortmentView: (view: AssortmentView) => void;
  canReadCompeititorPrices: boolean;
}

export function AssortmentViewRadio({
  selectedAssortmentView,
  selectAssortmentView,
  canReadCompeititorPrices,
}: Props) {
  const t = useMyAssortmentTFunction();

  const options: RadioFilterOption<AssortmentView>[] = useMemo(
    () => [
      { label: t('myAssortment.columnView.fullView'), value: 'ASSORTMENT_FULL' },
      { label: t('myAssortment.columnView.simpleView'), value: 'ASSORTMENT_SIMPLE' },
      { label: t('myAssortment.columnView.priceChanges'), value: 'PRICE_CHANGES' },
      {
        label: t('myAssortment.columnView.competitorPrices'),
        value: 'COMPETITOR_PRICES',
        hidden: !canReadCompeititorPrices,
      },
    ],
    [canReadCompeititorPrices, t]
  );

  return (
    <RadioFilterGroup
      label={`${t('myAssortment.filters.columnFilters')}:`}
      columns={2}
      options={options}
      value={selectedAssortmentView}
      onChange={selectAssortmentView}
    />
  );
}
